import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import { FormattedCurrency } from '../../../components/formatted-currency';
import ApplyButton from '../apply-button.component';
import { RateRecommendationBanner } from './rate-recommendation-banner';

import style from './rate-recommendation.module.less';
import { RecommendedShippingServiceName } from './recommended-shipping-service-name';

export const ShippingServiceRateRecommendation = ({
  className,
  theme = 'light',
  rateDifference,
  onApplyRec,
  shippingService,
  isComparingBYOAToWallet,
  onDismiss,
}) => {
  const message = isComparingBYOAToWallet ? messages.recommendationSwitchBYOAtoWalletService : messages.recommendationSaveWithService;

  return (
    <RateRecommendationBanner
      applyButton={
        <ApplyButton
          buttonClassName={style['rate-comparison-apply-button']}
          onClick={onApplyRec}
          amplitudeTrackingId='/orders#recommend-ups-ground'
          service={shippingService}
          theme='white'
        >
          <FormattedMessage {...messages.recommendationApplyButton} />
        </ApplyButton>
      }
      bannerText={
        <Text
          formattedMessageValues={{
            serviceName: <RecommendedShippingServiceName shippingServiceName={shippingService.name} />,
            s: (chunks) => <strong>{chunks}</strong>,
            savings: () => (
              <strong>
                <FormattedCurrency currencyCode={rateDifference.code} value={rateDifference.value} />
              </strong>
            ),
          }}
          textType={TextType.Paragraph}
          value={message}
        />
      }
      className={className}
      contentClassName={style['single-recommendation-banner-content']}
      onDismiss={onDismiss}
      theme={theme}
    />
  );
};

ShippingServiceRateRecommendation.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
};
